export enum GraphQLErrorCode {
  Unauthorized = "Unauthorized",
  Forbidden = "Forbidden",
  Unhandled = "",
  UserLocked = "UserLocked",
  PasswordExpired = "PasswordExpired",
}
